import { render } from "./DetailsListItem.vue?vue&type=template&id=f19490ae"
import script from "./DetailsListItem.vue?vue&type=script&lang=js"
export * from "./DetailsListItem.vue?vue&type=script&lang=js"

import "./DetailsListItem.vue?vue&type=style&index=0&id=f19490ae&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__